export default "__VITE_ASSET__21b09c46__"